import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { handleHttp, transformStr3, getformdataList, getformListItemsdatas } from "@/utils/utils";
import Swiper from 'swiper';
export default {
  name: 'exhibiton',
  data() {
    return {
      list: [],
      banners: [],
      scale: 1,
      isPc: false
    };
  },
  methods: {
    // 获取数据
    getData(page) {
      this.$api.getFormListByPage(this.$route.query.fid, '9d5f4ad1e63f7723b7190abee07e42a1aa5084d3028db91d73d6a5f2391a6610', page, 'likeNum').then(res => {
        if (res.totalRow > 0) {
          let formatDataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata[4] = item.itemformdata[4].length ? `https://museum.chaoxing.com/star3/origin/${item.itemformdata[4][0].objectId}.${item.itemformdata[4][0].suffix}` : '';
            return item;
          });
          this.list = this.list.concat(formatDataList);
          if (res.totalPage != page) {
            this.getData(page + 1);
          }
        }
      });
    },
    // 获取banner
    getBanner() {
      this.$api.getFormList(this.$route.query.fid, '0ada87df6f00a432f258b8968403fa18aa5084d3028db91d73d6a5f2391a6610').then(res => {
        if (res.total > 0) {
          let list = res.data.map(item => {
            let itemformdata = item.formData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformdataList(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
          this.banners = list;
          this.$nextTick(() => {
            if (this.isPc) {
              new Swiper('#certify1 .swiper-container', {
                slidesPerView: 1.5,
                centeredSlides: true,
                spaceBetween: 0,
                // loop: true,
                observer: true,
                observeParents: true,
                speed: 800,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false
                },
                pagination: {
                  el: '#certify1 .swiper-pagination'
                }
              });
            } else {
              new Swiper('#certify1 .swiper-container', {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 15,
                // loop: true,
                // loopedSlides: 3,
                observer: true,
                observeParents: true,
                speed: 800,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false
                },
                pagination: {
                  el: '#certify1 .swiper-pagination'
                }
              });
            }
          });
        }
      });
    },
    // 宽度
    setWidth() {
      if (window.innerWidth > 880 && window.innerWidth < 1500) {
        this.scale = window.innerWidth / 1500;
      }
      if (window.innerWidth > 880) {
        this.isPc = true;
      }
    },
    // 点赞
    zan(item, index) {
      let putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": item.isLike ? parseInt(item.itemformdata.likeNum) - 1 : parseInt(item.itemformdata.likeNum) + 1
        }],
        "alias": 'likeNum'
      }, {
        "compt": "editinput",
        "values": [{
          "val": item.itemformdata.museumName
        }],
        "alias": 'museumName'
      }];
      putParams = encodeURI(JSON.stringify(putParams));
      this.$api.editForm(this.$route.query.fid, item.id, putParams, 789900).then(res => {
        this.list[index].itemformdata.likeNum = item.isLike ? parseInt(this.list[index].itemformdata.likeNum) - 1 : parseInt(this.list[index].itemformdata.likeNum) + 1;
        item.isLike ? this.list[index].isLike = false : this.list[index].isLike = true;
      });
    },
    openUrl(url) {
      if (navigator.userAgent.toLowerCase().indexOf('chaoxingstudy') > -1) {
        jsBridge.postNotification('CLIENT_OPEN_URL', {
          'title': '',
          'loadType': '1',
          //打开方式，0在本页面打开，1使用客户端webview打开新页面，2打开系统浏览器
          'webUrl': url,
          'toolbarType': '2'
        });
        return;
      }
      location.href = url;
    }
  },
  created() {
    this.setWidth();
    this.getData(1);
    this.getBanner();
  },
  computed: {}
};